import "@fontsource/roboto/latin-400.css";
import "@fontsource/roboto/latin-500.css";
import "@fontsource/roboto/latin-700.css";

import reportWebVitals from "./reportWebVitals";

import("./bootstrap");

if (process.env.NODE_ENV === "development") {
    reportWebVitals((metric) => {
        console.log(metric.name, metric);
    });
}
